import { Mesh } from 'three';

import { NavMesh as RecastNavMesh, NavMeshQuery } from '@recast-navigation/core';
import {
  SoloNavMeshGeneratorConfig,
  SoloNavMeshGeneratorIntermediates,
} from '@recast-navigation/generators';
import { threeToSoloNavMesh } from '@recast-navigation/three';

const defaultNavmeshConfig: Partial<SoloNavMeshGeneratorConfig> = {
  // cell height - affects the height above the original mesh where navmesh is placed
  ch: 0.01,
  // cell size in XZ plane - affects the insets of the original mesh
  cs: 0.05,
};

export class NavMesh {
  private _navMeshQuery?: NavMeshQuery;

  public instance: RecastNavMesh;
  public intermediates: SoloNavMeshGeneratorIntermediates;

  constructor(meshes: Mesh[], config: Partial<SoloNavMeshGeneratorConfig> = defaultNavmeshConfig) {
    const mergedConfig = {
      ...defaultNavmeshConfig,
      ...config,
    };
    const {
      intermediates,
      navMesh,
      success,
      error = '',
    } = threeToSoloNavMesh(meshes, mergedConfig, true) as any;

    if (!success) {
      console.error('NavMesh is not valid', error);
      throw new Error('NavMesh is not valid');
    }
    this.instance = navMesh;
    this.intermediates = intermediates;
  }

  public get navMeshQuery(): NavMeshQuery {
    if (!this._navMeshQuery) {
      this._navMeshQuery = new NavMeshQuery(this.instance);
    }
    return this._navMeshQuery;
  }
}
